import { useLoading } from "../../LoadingContext";
import axios from "../../../api/axiosClient";
import { useIntl } from "react-intl";
import Box from "@mui/material/CardContent";
import { Button, Grid, Typography } from "@mui/material";
import CustomInput from "../CustomInput";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import PageHeader from "../PageHeader";
import { errorToast, handleError } from "../../../services/serviceBase";
import CustomTable from "../CustomTable";
import { useNavigate } from "react-router-dom";

const EditWarehouseDestinationsForRAList = (props) => {
  const { ids, handleSave } = props;
  const intl = useIntl();
  const { setLoading } = useLoading();
  const navigate = useNavigate();

  const [createdReturnFilesInfos, setCreatedReturnFilesInfos] = useState([]);
  const [columns, setColumns] = useState([]);
  const [destinationsToUpdate, setDestinationsToUpdate] = useState([]);


  useEffect(() => {
    getColumns();
  }, []);

  const getColumns = () => {
    setColumns([
      {
        field: "returnFileKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "UploadExcel.RAKey" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 250,
      },
      {
        field: "stealthShopOrCustomerCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "UploadExcel.From" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 50,
      },
      {
        field: "warehouseDestination",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "UploadExcel.TrecateWH" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 350,
        renderCell: RenderDestinationSelect,
      },
      {
        field: "affinityGroup",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "UploadExcel.AffinityGroup" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
      },
    ]);
  };

  useEffect(() => {
    if(Array.isArray(ids) && ids.length > 0){
      getCreatedReturnFilesInfos();
    }
  }, [])

  const getCreatedReturnFilesInfos = () => {
    const params = new URLSearchParams();
    ids.forEach(id => params.append('idReturnFileHeadList', id));
    setLoading(true);

    axios
      .get("/creditnotereturnfiles/createdreturnfiles", {params})
      .then((response) => {
        setLoading(false);
        setCreatedReturnFilesInfos(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const updateJDALocationDestinations = () => {
    setLoading(true);
    let data = destinationsToUpdate;
    let url = `/creditnotereturnfiles/warehousedestinations`;
    axios
      .put(url, data)
      .then(() => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "General.Saved" }))
        handleSave();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  function RenderDestinationSelect(props) {
      const [destination, setDestination] = useState("");
      const [destinations, setDestinations] = useState([]);
  
      useEffect(() => {
        handleDestinationChange();
      }, []);
  
      const handleDestinationChange = () => {
        getWarehouseDestinations(
          props.row.idRFType,
          props.row.idJDALocationDestination,
          setDestinations,
          setDestination
        );
      };
  
      const handleClickOnNewDestination = (event) => {
        setDestination(event);
        var data = destinationsToUpdate;
  
        let returnFile = data.find(
          (x) => x.idReturnFileHead == props.row.idReturnFileHead
        );
  
        if (returnFile != undefined) {
          returnFile.idJDALocationDestination = event;
        } else {
          data.push({
            idReturnFileHead: props.row.idReturnFileHead,
            idJDALocationDestination: event,
          });
        }
  
        setDestinationsToUpdate([...data]);
      };


  const getWarehouseDestinations = async (
    idRFType,
    idJDALocationDestination,
    setWHDestinations,
    setWHDestination
  ) => {
    setLoading(true);
    const params = new URLSearchParams([]);
    ids.forEach(id => params.append('idReturnFileHeadList', id));
    axios
      .get("/creditnotereturnfiles/" + idRFType + "/warehousedestinations", {
        params,
      })
      .then((response) => {
        setLoading(false);
        var selectWhdestinations = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectWhdestinations.push({
              text: x.jdaLocation + ' - ' + x.description,
              value: x.idJDALocationDestination,
              isPackaging: x.isPackaging,
            });
          });
        }
        setWHDestinations(selectWhdestinations);

        if (props.row.affinityGroup === "Packaging") {
          const packagingDestinations = selectWhdestinations.filter(
            (x) => x.isPackaging
          );

          if (packagingDestinations.length > 1) {
            toast.error(
              intl.formatMessage({
                id: "UploadExcel.MultiplePackagingDestinationsError",
              })
            );
          } else if (packagingDestinations.length === 1) {
            handleClickOnNewDestination(packagingDestinations[0].value);
            return;
          }
        }

        setWHDestination(idJDALocationDestination);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };
  
      return (
        <>
          {destinations.length > 0 ? (
            <CustomInput
              type="select"
              value={destination}
              valueRef={destination}
              selectItems={destinations}
              setValue={(e) => {
                handleClickOnNewDestination(e);
              }}
              //setOpen={handleDestinationChange}
              textCol={0}
              inputCol={12}
            />
          ) : (
            ""
          )}
        </>
      );
    }

  return (
    <>
      <PageHeader
        title={intl.formatMessage({ id: "UploadExcel.DossierCreated" })}
      />
      <Grid item md={12} mt={1}>
        <Box sx={{ mt: 2 }}>
          <CustomTable
            columns={columns}
            rows={createdReturnFilesInfos}
            id={"idReturnFileHead"}
            rowHeight={40}
            headerHeight={30}
            tableHeight={300}
          />
        </Box>
      </Grid>
      <Grid item md={12} display="flex" justifyContent="flex-end" pt={1}>
        <Button
          variant="contained"
          className="apeLigthBlueBackground"
          onClick={updateJDALocationDestinations}
        >
          {intl.formatMessage({ id: "General.Save" })}
        </Button>
      </Grid>
    </>
  );
};

export default EditWarehouseDestinationsForRAList;
